"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
const computeRowWidth = ({ visibleColumns, columnsWidth, hasVerticalScroll, layoutWidth, scrollbarWidth }) => {
    const width = visibleColumns.reduce((count, column) => count + columnsWidth[column.key], 0);
    // When monitor scale on Windows equal 125/175 then horizontal scroll is render, but row width correct.
    // Detect window scale and force correct row size
    const delta = window.devicePixelRatio % 0.5 && navigator.platform.includes('Win') ? 1 : 0;
    if (width < layoutWidth - scrollbarWidth) {
        if (hasVerticalScroll) {
            return layoutWidth - scrollbarWidth - delta;
        }
        return layoutWidth - delta;
    }
    return width - delta;
};
exports.default = computeRowWidth;
//# sourceMappingURL=computeRowWidth.js.map